import {
  CATEGORIES_FAILURE,
  CATEGORIES_LIST_LOADING,
  CATEGORIES_LOADING,
  CATEGORIES_SUCCESS,
  CATEGORY_PROGRESS_FAILURE,
  CATEGORY_PROGRESS_SUCCESS,
  PROGRESS_COUNT,
  PROGRESS_SUCCESS,
  SET_CATEGORY,
} from './constants';
import { createReducer } from './utils';

const defaultState = {
  loading: false,
  listLoading: false,
  categories: [],
  currentCategory: 'Todas',
  currentKey: null,
  progress: {},
  errorMessage: null,
};

// reducer

export const reducer = createReducer(defaultState, {
  [CATEGORIES_LIST_LOADING]: handleCategoriesListLoading,
  [CATEGORIES_LOADING]: handleCategoriesLoading,
  [CATEGORIES_SUCCESS]: handleCategoriesSuccess,
  [CATEGORIES_FAILURE]: handleCategoriesFailure,
  [CATEGORY_PROGRESS_FAILURE]: handleCategoryProgressFailure,
  [SET_CATEGORY]: handleSetCategory,
  [CATEGORY_PROGRESS_SUCCESS]: handleCategoryProgressSuccess,
});

function handleCategoriesListLoading(state) {
  return {
    ...state,
    listLoading: true,
    categories: [],
  };
}

function handleCategoriesLoading(state) {
  return {
    ...state,
    loading: true,
  };
}

function handleCategoriesSuccess(state, { payload: { response } }) {
  return {
    ...state,
    listLoading: false,
    categories: response,
  };
}

function handleCategoriesFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    listLoading: false,
    categories: [],
    errorMessage: error,
  };
}

function handleSetCategory(state, { payload: { category, key } }) {
  return {
    ...state,
    currentCategory: category,
    currentKey: key,
  };
}

function handleCategoryProgressSuccess(state, { payload: { response } }) {
  return {
    ...state,
    loading: false,
    progress: response,
  };
}

function handleCategoryProgressFailure(state) {
  return {
    ...state,
    loading: false,
  };
}

// actions

export function getCategoriesData(includeSubcategories = false) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: CATEGORIES_LIST_LOADING });

    const {
      stores: { currentStore },
    } = getState();


    try {
      const response = await dataSource.requestCategories({
        store: currentStore,
        include_subcategories: includeSubcategories,
      });
      response.unshift({
        value: null,
        name: 'Todas',
      });

      dispatch({ type: CATEGORIES_SUCCESS, payload: { response } });
    } catch (error) {
      dispatch({
        type: CATEGORIES_FAILURE,
        payload: { error },
      });
    }
  };
}

function countCategoryProgress(progress) {
  if (!progress) return [0, 0];
  const tasks = Object.values(progress);
  let total = 0;
  let pending = 0;

  tasks.forEach(element => {
    total += element['total'];
    pending += element['pending'];
  });
  return [total, pending];
}

export function setCategory(category, key) {
  return async (dispatch, getState, { services: { } }) => {
    const {
      categories: { progress },
      tasks: { progressTasksType },
    } = getState();

    try {
      let tasksType = {};
      let progressValues;

      if (key !== null) {
        tasksType = Object.assign({}, progress[key]);
        progressValues = countCategoryProgress(progress[key]);
      } else {
        tasksType = Object.assign({}, progressTasksType);
        progressValues = countCategoryProgress(tasksType);
      }

      dispatch({ type: SET_CATEGORY, payload: { category, key } });
      dispatch({
        type: PROGRESS_SUCCESS,
        payload: { progressTasksType: tasksType },
      });
      dispatch({
        type: PROGRESS_COUNT,
        payload: { total: progressValues[0], pending: progressValues[1] },
      });
    } catch (error) {
      console.log('setCategory error', error);
    }
  };
}

export function getCategoryProgress() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: CATEGORIES_LOADING });

    const {
      stores: { currentStore },
    } = getState();

    try {
      const response = await dataSource.requestCategoryProgress({
        store: currentStore,
      });

      dispatch({ type: CATEGORY_PROGRESS_SUCCESS, payload: { response } });
    } catch (error) {
      dispatch({
        type: CATEGORY_PROGRESS_FAILURE,
        payload: { error },
      });
    }
  };
}

export function resetCategory() {
  return async (dispatch, getState, { services: { } }) => {
    try {
      dispatch({
        type: SET_CATEGORY,
        payload: { category: 'Todas', key: null },
      });
    } catch (error) {
      console.log('resetCategory error', error);
    }
  };
}
